export default "__VITE_ASSET__QjpeBLSG__"